import { App, Button, Divider, Modal, Select, Spin } from "antd";
import { useEffect, useState } from "react"
import { InlineContent } from "../../../../../components/Shared";
import { feedCommentClaimDataList, useGetFeedCommentAdminByFeedCommentId } from "../../model";
import { useCreateOrUpdateFeedCommentHiddenAdmin } from "../../../feedAndCommentClaimManage/detail/model";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";

interface IProps {
    feedCommentId: number
    btnText?: string
    styles?: { btn?: React.CSSProperties }
}

const FeedCommentManageModal = ({ feedCommentId, btnText, styles }: IProps) => {
    const queryClient = useQueryClient()
    const [open, setOpen] = useState<boolean>(false);
    const responseQuery = 'id nickName content createdDate feedCommentHiddenId isHidden feedId reason status';
    const { data, isError, isPending, isSuccess } = useGetFeedCommentAdminByFeedCommentId<IFeedCommentAdminResponse>(feedCommentId, open, responseQuery);
    const [selectReason, setSelectReason] = useState<string>('');
    const [selectStatus, setSelectStatus] = useState<string>('null');
    const createOrUpdateFeedCommentHiddenAdmin = useCreateOrUpdateFeedCommentHiddenAdmin();
    const { message } = App.useApp();

    const onFinish = () => {
        const createOrUpdateFeedCommentHiddenAdminRequest: ICreateOrUpdateFeedCommentHiddenAdminRequest = {
            feedCommentId: feedCommentId,
            status: selectStatus === 'null' ? null : selectStatus,
            reason: selectReason
        }

        createOrUpdateFeedCommentHiddenAdmin.mutate(createOrUpdateFeedCommentHiddenAdminRequest, {
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ['getAllFeedCommentAdmin'] })
                message.success('상태 변경 성공!'); setOpen(false)
            },
        })
    }

    useEffect(() => {
        if (!data || !isSuccess) return;
        setSelectStatus(data.status ?? 'null')
        setSelectReason(data.reason ?? '')
    }, [isSuccess])
    if (isError) return <Spin size='large' />;

    return <>
        <div onClick={() => setOpen(true)} style={{ color: 'var(--ant-color-link)', cursor: 'pointer', ...styles?.btn }}>
            {btnText ?? '관리'}
        </div >
        <Modal centered width={500} open={open} onCancel={() => setOpen(false)} onClose={() => setOpen(false)} footer={null} loading={isPending}>
            <div style={{ fontSize: '16px', fontWeight: 700 }}>
                댓글 숨김 관리
            </div>
            <Divider style={{ marginBlock: '12px' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', marginBottom: '48px' }}>
                <InlineContent styles={{ title: { flex: 2 } }} title="댓글ID" content={data?.id} />
                <InlineContent styles={{ title: { flex: 2 } }} title="작성자 닉네임" content={data?.nickName} />
                <InlineContent styles={{ title: { flex: 2 } }} title="내용" content={data?.content} />
                <InlineContent styles={{ title: { flex: 2 } }} title="원본 게시글 ID" content={<Link to={`/community/feed-manage/${data?.feedId}`}>{data?.feedId}</Link>} />
                <InlineContent styles={{ title: { flex: 2 } }} title="처리 상태" content={<Select loading={createOrUpdateFeedCommentHiddenAdmin.isPending} defaultValue={String(data?.status)} onChange={q => setSelectStatus(q)}>
                    <Select.Option value='null'>미처리</Select.Option>
                    <Select.Option value='complete'>처리완료(노출유지)</Select.Option>
                    <Select.Option value='hidden'>숨김처리</Select.Option>
                </Select>} />
                {selectStatus === 'hidden' &&
                    <InlineContent styles={{ title: { flex: 2 } }} title="숨긴 사유" content={<div>
                        <Select defaultValue={data?.reason} value={selectReason} options={feedCommentClaimDataList} onChange={q => setSelectReason(q)} style={{ width: '300px' }} />
                    </div>} />}
            </div>

            <div style={{ display: 'flex', justifyContent: 'center', gap: '8px' }}>
                <Button onClick={() => setOpen(false)}>취소</Button>
                <Button onClick={() => onFinish()} type='primary' loading={createOrUpdateFeedCommentHiddenAdmin.isPending}>저장</Button>
            </div>
        </Modal>
    </>
}

export default FeedCommentManageModal